import React from 'react'
import { makeStyles } from 'tss-react/mui'

import { Theme, Typography } from '@mui/material'

import { SubspaceListViewProvider } from './SubspaceListViewStore'
import { SubspaceListViewActions } from './SubspaceListViewActions.component'
import { SubspaceListViewContent } from './SubspaceListViewContent.component'

export function SubspaceListView() {
  const { classes } = useStyles()
  return (
    <SubspaceListViewProvider>
      <div className={classes.headerContainer}>
        <Typography className={classes.headline}>Subspaces</Typography>
        <SubspaceListViewActions className={classes.headerActions} />
      </div>
      <SubspaceListViewContent className={classes.content} />
    </SubspaceListViewProvider>
  )
}

const useStyles = makeStyles()(({ spacing, typography, breakpoints }: Theme) => ({
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing(2),
  },
  headerActions: {
    display: 'flex',
  },
  content: {
    position: 'relative',
    minHeight: spacing(50),
  },
  headline: {
    display: 'inline-block',
    fontSize: typography.h5.fontSize,
    [breakpoints.down('sm')]: {
      fontSize: typography.subtitle1.fontSize,
    },
  },
}))
